export default "__VITE_ASSET__Bvm4IKw7__"